export const getNameInitials = ({
  firstName,
  lastName,
}: {
  firstName: string;
  lastName: string;
}) => {
  return `${firstName.slice(0, 1)}${lastName ? lastName.slice(0, 1) : ''}`;
};
